module.exports = __webpack_public_path__ + "static/img/rl.02dc178.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/games/games_white/rl.svg
// module id = TvMI
// module chunks = 35